import React from 'react';
import styled from 'styled-components';

interface SAVStampProps {
  size?: number;
  className?: string;
}

const StampContainer = styled.div<{ $size: number }>`
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  position: relative;
  display: inline-block;
`;

const SAVStamp: React.FC<SAVStampProps> = ({ size = 120, className }) => {
  return (
    <StampContainer $size={size} className={className}>
      <img
        src="/images/sav.png"
        alt="SAV Stamp"
        width={size}
        height={size}
        style={{
          objectFit: 'contain',
          filter: `
            contrast(1.1)
            brightness(0.95)
            sepia(0.1)
          `,
          background: 'transparent',
          transform: 'rotate(-2deg)',
          opacity: 0.3,
          mixBlendMode: 'multiply'
        }}
      />
    </StampContainer>
  );
};

export default SAVStamp;
